import React, { useState, useEffect } from 'react';
import { Div, Row, Col } from '@pinpoint/design-kit';

/* eslint-disable react/prop-types */

function Menu({ options, Component, componentProps, leftColSize = '4', rightColSize = '8' }) {
  const [selectedOption, setSelectedOption] = useState({});

  useEffect(() => {
    if (options.length > 0) {
      setSelectedOption(options[0]);
    }
    // NOTE: needs to run once on load
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Row>
      <Col size={leftColSize}>
        {options.map(({ title, subTitle, key }) => (
          <Div
            cursor="pointer"
            onClick={() => {
              setSelectedOption({ title, subTitle, key });
            }}
            border={{ r: key === selectedOption.key ? '4px solid' : '2px solid' }}
            borderColor={key === selectedOption.key ? 'brand500' : 'gray200'}
            bg={key === selectedOption.key ? 'gray200' : 'gray100'}
            hoverBg="gray200"
            p="1rem"
          >
            <Div
              textSize="subtitle"
              m={{ l: '0.5rem', y: '0.25rem' }}
              textColor={key === selectedOption.key ? 'tabSelected' : 'tabRest'}
            >
              {title}
            </Div>
            <Div m={{ l: '0.5rem' }} textColor={key === selectedOption.key ? 'tabSelected' : 'tabRest'}>
              {subTitle}
            </Div>
          </Div>
        ))}
      </Col>
      <Col size={rightColSize}>
        <Component option={selectedOption} {...componentProps} />
      </Col>
    </Row>
  );
}

export default Menu;
